var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"btn-scroll-top",class:_vm.clazz,attrs:{"href":_vm.idScroll,"tabindex":""},on:{"scroll":_vm.handleScroll}},[_c('i',{staticClass:"banana banana-chevron-up",attrs:{"aria-hidden":"true"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }